
export enum SafetyRatingTypeEnum {
    FullScore = -3,
    Partial = -2,
    NA = -1,
    Score0 = 0,
    Score1 = 1,
    Score2 = 2
}